import { theme } from '@fairygodboss/ui';

const stripPxFromString = (string) => {
    return Number(string?.slice(0, -2));
};

export const getCardDimensions = (windowWidth) => {
    const { breakpoints } = theme;
    const { sm, md, lg } = breakpoints;
    const imageRatio = 500 / 281;

    if (!windowWidth) return;

    if (windowWidth >= stripPxFromString(lg)) {
        const cardDimensions = {
            width: 376,
            height: 360,
        };
        return cardDimensions;
    }
    if (windowWidth >= stripPxFromString(md)) {
        const padding = 96;
        const width = (windowWidth - padding) / 3;
        const imageHeight = width / imageRatio;
        const cardDimensions = {
            width,
            imageHeight,
            height: imageHeight + 178,
        };
        return cardDimensions;
    }
    if (windowWidth >= stripPxFromString(sm)) {
        const padding = 48;

        // const padding = (windowWidth / 8) * 2 + 8;
        const width = (windowWidth - padding) / 2;
        const imageHeight = width / imageRatio;
        const cardDimensions = {
            width,
            imageHeight,
            height: imageHeight + 130,
        };
        return cardDimensions;
    }
};

/*
    carousel default behavior populates fields from top down, this function will rearange the items so they appear in the correct sorted order
*/
export const reshapeMatrix = (arr, width) => {
    const { breakpoints } = theme;
    const { sm, md } = breakpoints;
    if (!width || width < stripPxFromString(sm)) {
        return arr;
    }
    const isSm = width < stripPxFromString(md);

    let list = [];
    const listOfLists = [];
    arr.forEach((i, idx) => {
        list.push(i);
        if (list.length > 5) {
            listOfLists.push(list);
            list = [];
        }
        if (arr?.length - 1 === idx && list?.length) {
            listOfLists.push(list);
        }
    });
    const newList = [];

    if (isSm) {
        listOfLists.forEach((l) => {
            newList.push([l[0], l[2], l[4], l[1], l[3], l[5]]);
        });
    } else {
        listOfLists.forEach((i) => {
            const secondArray = i;
            const firstArray = secondArray.splice(0, 3);
            const reshaped = firstArray.map((j, idx) => {
                return [j, secondArray[idx]];
            });
            newList.push(reshaped.flat());
        });
    }

    return newList?.flat();
};
